const FALLBACK_PROJECT_NAME = 'General'

const IGNORED_PATH_SEGMENTS: ReadonlySet<string> = new Set([
  'localhost',
  '127.0.0.1',
  '0.0.0.0',
  'tmp',
  'temp',
  'var',
  'home',
  'users',
  'user',
])

export function extractProjectName(path: string | undefined | null): string {
  const pathSeparatorRegex = /[/\\]/
  const wordSeparatorRegex = /[-_.]/g
  const whitespaceRegex = /\s+/g

  if (!path) {
    return FALLBACK_PROJECT_NAME
  }

  const cleanedPath = path.replace(/^https?:\/\//, '').replace(/:\d+.*$/, '')

  const segments = cleanedPath.split(pathSeparatorRegex).filter(Boolean)

  const lastFolder = [...segments]
    .reverse()
    .find((segment) => !IGNORED_PATH_SEGMENTS.has(segment.toLowerCase()))

  if (!lastFolder) {
    return FALLBACK_PROJECT_NAME
  }

  const userFriendlyName = lastFolder
    .replaceAll(wordSeparatorRegex, ' ')
    .replaceAll(whitespaceRegex, ' ')
    .trim()

  if (!userFriendlyName) {
    return FALLBACK_PROJECT_NAME
  }

  return userFriendlyName
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ')
}
